import React, { useState,useEffect } from 'react';
import Loader from './../img/loader.svg';
export const Clients = () => {
  const googleSpreadBookmarks= 'https://spreadsheets.google.com/feeds/list/1QreeDxWPsP9s2FzzvygdpYDFRKaPGPFojNfy_RPR4MI/1/public/values?alt=json' // Si les champs sont ok
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(0)
  const [filterProspect, setFilterProspect] = useState('')
  useEffect(() => {
      
      fetch(googleSpreadBookmarks)
      .then(res => res.json()
      )
      .then(
        (result) => {
          let dataFilter = result.feed.entry
         // filtre par ordre alphabetique
          function compare( a, b ) {
            if ( a.gsx$raisonsociales.$t < b.gsx$raisonsociales.$t  ){
              return -1;
            }
            if ( a.gsx$raisonsociales.$t  > b.gsx$raisonsociales.$t  ){
              return 1;
            }
            return 0;
          }
          ;
          setData(dataFilter.sort(compare))   
        
    

      return
         
  
          
        },
        (error) => {
            setData('error')
            
        }
      )
   return ()=> setData([])
  }, [refresh])
 





  return (

    <div id="articleContent" className="prospect">
      <a class="button only" target="_blank"   onClick={(event) => {window.print()} }>Imprimer cette liste</a>
      <form className="searchProspect">
      <input placeholder="Rechercher un prospect par raison sociales, nom, prénom ou numéro de téléphone" type="search" onChange={(e) => {setFilterProspect(e.target.value.toLowerCase()) }} />
      
        </form>
        <table>
          <thead>
              <tr>
                <th>Raison sociale</th>
                <th>Info sur l'entreprise</th>
                <th>Contact</th>
                <th>Commentaires</th>
                <th>Statut</th>
                <th></th>
              </tr>
              </thead>
              <tbody>

              {
                    data === "error" ? <tr><td colSpan="2">Les favoris ne peuvent être affichés pour le moment, merci de votre compréhension.</td></tr> :
                    data.length > 0 ?
                    data.filter(filtre => filtre.gsx$raisonsociales.$t.toLowerCase().includes(filterProspect) || filtre.gsx$telephone.$t.toLowerCase().includes(filterProspect) || filtre.gsx$prenom.$t.toLowerCase().includes(filterProspect)||filtre.gsx$nom.$t.toLowerCase().includes(filterProspect))
                    .map((item) => {
                                    return (
                                        <tr key={item.gsx$id.$t}>
                                          <td>{item.gsx$raisonsociales.$t}</td>
                                          <td>
                                            <ul>
                                              <li>{item.gsx$adresse.$t}</li>
                                              <li>{item.gsx$cp.$t}</li>
                                              <li>{item.gsx$ville.$t}</li>
                                              <li>{item.gsx$pays.$t}</li>
                                              </ul>
                                          </td>
                                          <td>  
                                            <ul>
                                              <li>{item.gsx$fonction.$t}</li>
                                              <li>{item.gsx$prenom.$t} {item.gsx$nom.$t}</li>
                                              <li>{item.gsx$telephone.$t}</li>
                                              <li>{item.gsx$email.$t}</li>
                                            </ul>
                                          </td>
                                          <td dangerouslySetInnerHTML={{__html:item.gsx$commentaires.$t}}></td>
                                          <td className={item.gsx$statut.$t==="Prospect"? "prospect":item.gsx$statut.$t==="Client"?"client":"client"}>
                                            
                                            {item.gsx$statut.$t}</td>
                                          <td>
                                            <a target="_blank" href="https://docs.google.com/spreadsheets/d/1QreeDxWPsP9s2FzzvygdpYDFRKaPGPFojNfy_RPR4MI/edit#gid=0"><svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 477.873 477.866"><g transform="translate(0 -0.004)"><path d="M392.533,238.937A17.067,17.067,0,0,0,375.466,256V426.67A17.067,17.067,0,0,1,358.4,443.737H51.2A17.067,17.067,0,0,1,34.133,426.67V85.337A17.067,17.067,0,0,1,51.2,68.27H256a17.066,17.066,0,1,0,0-34.133H51.2A51.2,51.2,0,0,0,0,85.337V426.67a51.2,51.2,0,0,0,51.2,51.2H358.4a51.2,51.2,0,0,0,51.2-51.2V256A17.067,17.067,0,0,0,392.533,238.937Z" fill="#879eaf"/><path d="M458.742,19.142a65.326,65.326,0,0,0-92.4.011l-224.8,224.784a17.254,17.254,0,0,0-4.113,6.673l-34.133,102.4a17.068,17.068,0,0,0,16.179,22.46,17.336,17.336,0,0,0,5.393-.87l102.4-34.133a17.072,17.072,0,0,0,6.673-4.13l224.8-224.8A65.333,65.333,0,0,0,458.742,19.142Z" fill="#879eaf"/></g></svg></a>
                                          </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr className="loader"><td colSpan="6"><img src={Loader} alt="loader" /></td></tr>
                        }

              </tbody>
        
        </table>
 
      </div>
    )
}
